import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Modal } from '@vectord/components';
import concat from 'lodash/concat';

import {
  addSuperBatchesModalStateSelector,
  getSbatGroupsSuperBatchIds,
  selectedBulkUpdateSbatGroupsSelector,
  setAddSuperBatchesModalState,
} from 'features/classCreation';
import AddSuperBatchesToggleChips from '../AddSuperBatchesToggleChips';
import BulkAddSuperBatchesButton from '../BulkAddSuperBatchesButton';
import Field from 'components/Field';
import SectionHeading from 'components/SectionHeading';
import SelectedSbatGroupsForBulkUpdate from '../SelectedSbatGroupsForBulkUpdate';
import styles from './BulkAddSuperBatchesModal.module.scss';
import SuperBatchSelect from 'components/SuperBatchSelect';

export default function BulkAddSuperBatchesModal() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(addSuperBatchesModalStateSelector);
  const [selectedSuperBatches, setSelectedSuperBatches] = useState([]);
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);

  const excludedSuperBatchIds = useMemo(() => {
    const newSuperBatchIds = selectedSuperBatches.map((o) => o.value);
    const currentSuperBatchIds = getSbatGroupsSuperBatchIds(selectedSbatGroups);

    return concat(newSuperBatchIds, currentSuperBatchIds);
  }, [selectedSuperBatches, selectedSbatGroups]);

  const handleModalClose = useCallback(() => {
    dispatch(setAddSuperBatchesModalState(false));
    setSelectedSuperBatches([]);
  }, [dispatch]);

  const handleBulkAddSuperBatchesChange = useCallback((value) => {
    setSelectedSuperBatches(value);
  }, []);

  return (
    <Modal
      isOpen={isModalOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className={styles.root}
      containerClassName={styles.containerClassName}
      size="large"
    >
      <SectionHeading
        title={
          <>
            <Icon
              name="plus-circle"
              className="primary m-r-xxs"
            />
            Add Batch/es
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
      />
      <SelectedSbatGroupsForBulkUpdate />
      <Field
        label="Select Batch/es"
        labelClassName={styles.selectBatchText}
      >
        <SuperBatchSelect
          excludedSuperBatchIds={excludedSuperBatchIds}
          onChange={handleBulkAddSuperBatchesChange}
          value={selectedSuperBatches}
          placeholder="Batch/es"
          isMulti
        />
      </Field>
      <AddSuperBatchesToggleChips
        selectedSuperBatches={selectedSuperBatches}
        setSelectedSuperBatches={setSelectedSuperBatches}
      />
      {selectedSuperBatches.length > 0 && (
        <BulkAddSuperBatchesButton
          selectedSuperBatches={selectedSuperBatches}
          setSelectedSuperBatches={setSelectedSuperBatches}
        />
      )}
    </Modal>
  );
}
